var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonutChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8029_2642)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_2642",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 0H0V120H120V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_2642)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8029_2642",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 0H0V120H120V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8029_2642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 59.9997C0 28.2066 24.7278 2.1892 56 0.130859V32.2832C42.4308 34.2241 32 45.8938 32 59.9997C32 75.4636 44.536 88 60 88C66.2894 88 72.0945 85.9256 76.7688 82.4248L99.504 105.161C88.9504 114.4 75.129 120 60 120C26.8629 120 0 93.1368 0 59.9997Z",
    fill: "url(#paint0_linear_8029_2642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.161 99.5041C114.401 88.9497 120 75.1287 120 59.9998C120 51.7316 118.327 43.8541 115.302 36.687L86.0418 49.6919C87.3058 52.882 88.0002 56.3598 88.0002 59.9998C88.0002 66.289 85.9266 72.094 82.4258 76.7683L105.161 99.5041Z",
    fill: "url(#paint1_linear_8029_2642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 32.2832V0.130859C84.3328 1.46916 101.898 12.9359 111.701 29.5333L82.0328 42.7189C77.685 37.1833 71.2962 33.3268 64 32.2832Z",
    fill: "url(#paint2_linear_8029_2642)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8029_2642",
    x1: 49.752,
    y1: 0.130859,
    x2: 49.752,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8029_2642",
    x1: 101.213,
    y1: 36.687,
    x2: 101.213,
    y2: 99.5041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8029_2642",
    x1: 87.8505,
    y1: 0.130859,
    x2: 87.8505,
    y2: 42.7189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8029_2642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutChart);
export default __webpack_public_path__ + "static/media/DonutChart.e98560c24d39c894517abeb99080b84c.svg";
export { ForwardRef as ReactComponent };